import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const tomos = [{
  num: 1,
  title: 'Fundamentos sin frustración',
  desc: 'Qué comprar, cómo empezar y evitar gastar de más.',
  color: 'pink',
  price: '$7.990'
}, {
  num: 2,
  title: 'Preparación correcta',
  desc: 'Bastidor, emulsión y armado sin errores.',
  color: 'cyan',
  price: '$7.990'
}, {
  num: 3,
  title: 'Estampado profesional',
  desc: 'Cómo lograr resultados limpios y duraderos.',
  color: 'yellow',
  price: '$8.990'
}, {
  num: 4,
  title: 'Errores comunes y soluciones',
  desc: 'Cómo arreglar fallos típicos y no arruinar trabajos.',
  color: 'pink',
  price: '$7.990'
}, {
  num: 5,
  title: 'Optimización del proceso',
  desc: 'Cómo mejorar calidad y velocidad.',
  color: 'cyan',
  price: '$7.990'
}, {
  num: 6,
  title: 'Cómo ganar dinero con serigrafía',
  desc: 'Precios, ideas de negocio y primeros clientes.',
  color: 'yellow',
  price: '$9.040'
}];
const colorMap = {
  pink: {
    text: 'text-accent-pink',
    bg: 'bg-accent-pink',
    border: 'border-accent-pink/30',
    hoverBorder: 'hover:border-accent-pink',
    glow: 'group-hover:shadow-glow-pink'
  },
  cyan: {
    text: 'text-accent-cyan',
    bg: 'bg-accent-cyan',
    border: 'border-accent-cyan/30',
    hoverBorder: 'hover:border-accent-cyan',
    glow: 'group-hover:shadow-glow-cyan'
  },
  yellow: {
    text: 'text-accent-yellow',
    bg: 'bg-accent-yellow',
    border: 'border-accent-yellow/30',
    hoverBorder: 'hover:border-accent-yellow',
    glow: 'group-hover:shadow-glow-yellow'
  }
};
export function TomosSection() {
  return <section className="py-12 bg-darker relative" data-id="element-234">
      <div className="container mx-auto px-4" data-id="element-235">
        <div className="text-center mb-8" data-id="element-236">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold mb-4" data-id="element-237">
            ¿QUÉ INCLUYE EL{' '}
            <span className="text-gradient-primary" data-id="element-238">KIT DE SERIGRAFÍA PRO</span>
            ?
          </motion.h2>
          <div className="w-24 h-1 bg-accent-cyan mx-auto rounded-full" data-id="element-239" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto" data-id="element-240">
          {tomos.map((tomo, index) => {
          const styles = colorMap[tomo.color as keyof typeof colorMap];
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`group relative bg-card rounded-2xl p-5 border ${styles.border} ${styles.hoverBorder} transition-all duration-300 ${styles.glow}`} data-id="element-241">
                <div className={`absolute -top-4 -left-4 w-10 h-10 rounded-full ${styles.bg} flex items-center justify-center text-dark font-bold text-lg shadow-lg`} data-id="element-242">
                  {tomo.num}
                </div>

                <div className="flex items-start justify-between mb-4" data-id="element-243">
                  <BookOpen className={`w-8 h-8 ${styles.text} opacity-80`} data-id="element-244" />
                  <span className={`text-sm font-bold ${styles.text} bg-white/5 px-3 py-1 rounded-full`} data-id="element-245">
                    Valor: {tomo.price}
                  </span>
                </div>

                <h3 className="text-xl font-bold mb-2 text-white" data-id="element-246">
                  {tomo.title}
                </h3>
                <p className="text-gray-400" data-id="element-247">{tomo.desc}</p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-8 text-center" data-id="element-248">
          <div className="inline-flex flex-col items-center gap-2 bg-card border border-accent-cyan/20 rounded-2xl px-8 py-5" data-id="element-249">
            <div className="flex items-center gap-3" data-id="element-250">
              <span className="text-gray-400 text-lg" data-id="element-251">
                Valor total de los 6 tomos:
              </span>
              <span className="text-2xl font-bold text-gray-500 line-through" data-id="element-252">
                $49.990
              </span>
            </div>
            <p className="text-accent-cyan font-bold text-2xl md:text-3xl uppercase" data-id="element-253">
              🔥 Aprovechalo hoy por solo{' '}
              <span className="text-accent-yellow" data-id="element-254">$19.990</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}